import script from './component-lib.esm19.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.embedType !== 'embed_chat' ? _c('div', {
    attrs: {
      "id": _vm.playerId
    }
  }) : _c('iframe', {
    attrs: {
      "scrolling": "no",
      "src": "https://www.twitch.tv/embed/" + _vm.id + "/chat?parent=" + _vm.location + "&autoplay&muted",
      "width": "100%",
      "height": "100%",
      "frameborder": "0"
    }
  });
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = undefined;
/* scoped */
const __vue_scope_id__ = "data-v-4f4cc282";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var TwitchChannel = __vue_component__;
export { TwitchChannel as default };